<template>
  <ckeditor
    id="editor"
    dir="rtl"
    :editor="editor_type"
    v-model="text"
    :config="editorConfig"
    @input="updateDate"
  ></ckeditor>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import Alignment from "@ckeditor/ckeditor5-alignment/src/alignment.js";
import Autoformat from "@ckeditor/ckeditor5-autoformat/src/autoformat.js";
import BlockQuote from "@ckeditor/ckeditor5-block-quote/src/blockquote.js";
import Bold from "@ckeditor/ckeditor5-basic-styles/src/bold.js";
import CKFinder from "@ckeditor/ckeditor5-ckfinder/src/ckfinder.js";
import CKFinderUploadAdapter from "@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter.js";
import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials.js";
import ExportToPDF from "@ckeditor/ckeditor5-export-pdf/src/exportpdf.js";
import FontBackgroundColor from "@ckeditor/ckeditor5-font/src/fontbackgroundcolor.js";
import FontColor from "@ckeditor/ckeditor5-font/src/fontcolor.js";
import FontFamily from "@ckeditor/ckeditor5-font/src/fontfamily.js";
import FontSize from "@ckeditor/ckeditor5-font/src/fontsize.js";
import Heading from "@ckeditor/ckeditor5-heading/src/heading.js";
import Highlight from "@ckeditor/ckeditor5-highlight/src/highlight.js";
// import Image from '@ckeditor/ckeditor5-image/src/image.js';
// import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption.js';
// import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize.js';
// import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle.js';
// import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar.js';
// import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload.js';
import Indent from "@ckeditor/ckeditor5-indent/src/indent.js";
import IndentBlock from "@ckeditor/ckeditor5-indent/src/indentblock.js";
import Italic from "@ckeditor/ckeditor5-basic-styles/src/italic.js";
import Link from "@ckeditor/ckeditor5-link/src/link.js";
import List from "@ckeditor/ckeditor5-list/src/list.js";
import MediaEmbed from "@ckeditor/ckeditor5-media-embed/src/mediaembed.js";
import PageBreak from "@ckeditor/ckeditor5-page-break/src/pagebreak.js";
import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph.js";
import PasteFromOffice from "@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice";
import RemoveFormat from "@ckeditor/ckeditor5-remove-format/src/removeformat.js";
import SpecialCharacters from "@ckeditor/ckeditor5-special-characters/src/specialcharacters.js";
import SpecialCharactersLatin from "@ckeditor/ckeditor5-special-characters/src/specialcharacterslatin.js";
import SpecialCharactersMathematical from "@ckeditor/ckeditor5-special-characters/src/specialcharactersmathematical.js";
import Table from "@ckeditor/ckeditor5-table/src/table.js";
import TableCellProperties from "@ckeditor/ckeditor5-table/src/tablecellproperties";
import TableProperties from "@ckeditor/ckeditor5-table/src/tableproperties";
import TableToolbar from "@ckeditor/ckeditor5-table/src/tabletoolbar.js";
import TextTransformation from "@ckeditor/ckeditor5-typing/src/texttransformation.js";
// import Title from '@ckeditor/ckeditor5-heading/src/title.js';
import TodoList from "@ckeditor/ckeditor5-list/src/todolist";
import Underline from "@ckeditor/ckeditor5-basic-styles/src/underline.js";
import WordCount from "@ckeditor/ckeditor5-word-count/src/wordcount.js";
import Strikethrough from "@ckeditor/ckeditor5-basic-styles/src/strikethrough";
import Code from "@ckeditor/ckeditor5-basic-styles/src/code";
import Subscript from "@ckeditor/ckeditor5-basic-styles/src/subscript";
import Superscript from "@ckeditor/ckeditor5-basic-styles/src/superscript";
// import MathType from '@wiris/mathtype-ckeditor5';
// import EasyImage from '@ckeditor/ckeditor5-easy-image/src/easyimage';

import UploadAdapter from "@/shared/UploadAdapter";

import { mapActions } from "vuex";

export default {
  props: {
    value: {},
    editor: {
      default: null,
    },
    config: {},
    dir: {},
    resource: {
      type: [String, Number],
      default: "salam",
    },
    resourceId: {
      type: [String, Number],
      default: "salam",
    },
    toolbarItems: {
      type: Array,
      default: () => [
        "heading",
        "alignment",
        "indent",
        "outdent",
        "|",
        "highlight",
        // 'highlight:yellowMarker', 'highlight:greenMarker', 'highlight:pinkMarker',
        // 'highlight:greenPen', 'highlight:redPen', 'removeHighlight',
        "fontFamily",
        "fontSize",
        "fontColor",
        "fontBackgroundColor",
        "|",
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "code",
        "subscript",
        "superscript",
        "removeFormat",
        "|",
        "insertTable",
        "tableColumn",
        "tableRow",
        "mergeTableCells",
        "|",

        "blockQuote",
        "bulletedList",
        "numberedList",
        "todoList",
        "|",
        "imageUpload",
        "link",
        "undo",
        "redo",
        "|",
        // 'MathType',
        // 'ChemType'
      ],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editor_type: ClassicEditor,
      editorConfig: {
        plugins: [
          Alignment,
          Autoformat,
          BlockQuote,
          Bold,
          CKFinder,
          CKFinderUploadAdapter,
          Essentials,
          ExportToPDF,
          FontBackgroundColor,
          FontColor,
          FontFamily,
          FontSize,
          Heading,
          Highlight,
          // Image,
          // ImageCaption,
          // ImageResize,
          // ImageStyle,
          // ImageToolbar,
          // ImageUpload,
          Indent,
          IndentBlock,
          Italic,
          Link,
          List,

          MediaEmbed,
          PageBreak,
          Paragraph,
          PasteFromOffice,
          RemoveFormat,
          SpecialCharacters,
          SpecialCharactersLatin,
          SpecialCharactersMathematical,
          Table,
          TableCellProperties,
          TableProperties,
          TableToolbar,
          TextTransformation,

          TodoList,
          Underline,
          WordCount,
          Strikethrough,
          Code,
          Subscript,
          Superscript,
          // MathType,
          // EasyImage,
          this.uploader,
        ],
        toolbar: {
          items: this.toolbarItems,
        },
        fontFamily: {
          options: [
            "default",
            "B Titr Bold",
            "B Nazanin",
            "IRANSans",
            "Tahoma, Arial, sans-serif",
            "Ubuntu Mono, Courier New, Courier, monospace",
          ],
        },
        alignment: {
          // options: ['left', 'right']
        },
        image: {
          toolbar: [
            "imageStyle:alignLeft",
            "imageStyle:alignCenter",
            "imageStyle:alignRight",
            "|",
            "imageStyle:side",
            "|",
            "imageResize",
            "|",
            "imageTextAlternative",
          ],
          styles: ["alignLeft", "alignCenter", "alignRight", "side"],

          // Configure the available image resize options.
          resizeOptions: [
            {
              name: "imageResize:original",
              label: "اندازه اصلی",
              value: null,
            },
            {
              name: "imageResize:50",
              label: "50%",
              value: "50",
            },
            {
              name: "imageResize:75",
              label: "75%",
              value: "75",
            },
          ],
        },
        table: {
          contentToolbar: [
            "tableColumn",
            "tableRow",
            "mergeTableCells",
            "tableProperties",
            "tableCellProperties",
          ],
        },
        // This value must be kept in sync with the language defined in webpack.config.js.
        language: "fa",
        // image: {
        //   extraPlugins: [this.uploader],
        // },
        // language: {
        //   // // language: fa,
        //   // The UI will be fa.
        //   ui: "fa",
        //   // But the content will be edited in fa.
        //   content: "fa"
        // },
      },
      text: "",
    };
  },
  methods: {
    ...mapActions("fileManagement", ["changeResource", "changeResourceId"]),
    uploader(editor) {
      let resource = this.resource;
      editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
        return new UploadAdapter(loader, resource, this.resourceId);
      };
    },
    updateDate() {
      this.$emit("input", this.text);
    },
  },
  created() {
    this.text = this.value;
    this.editor_type = this.editor ? this.editor : ClassicEditor;
    this.changeResource(this.resource);
    this.changeResourceId(this.resourceId);
  },
  watch: {
    value(oldValue, newValue) {
      this.text = oldValue;
    },
    resource(newValue) {
      this.changeResource(newValue);
    },
    resourceId(newValue) {
      this.changeResourceId(newValue);
    },
  },
};
</script>

<style>
.ck-editor {
  padding-top: 8px !important;
}
</style>
